import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Navbar.css";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";

export default function Navbar({ routes }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const [serviceOpen, setServiceOpen] = useState(false);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const closeMenu = () => setMenuOpen(false);

  const toggleServiceDropdown = () => setServiceOpen(!serviceOpen);

  return (
    <header className="navbar-container">
      <div className="navbar">
        {/* Left Side - Hamburger + Menu */}
        <div className="navbar-left">
          <div className="navbar-toggle" onClick={toggleMenu}>
            {menuOpen ? <CloseIcon /> : <MenuIcon />}
          </div>

          <ul className={`navbar-menu ${menuOpen ? "active" : ""}`}>
            {routes.map(({ name, path, target }) => {
              if (name === "Services") {
                return (
                  <li
                    key={name}
                    className="nav-item dropdown"
                    onMouseEnter={() => setServiceOpen(true)}
                    onMouseLeave={() => setServiceOpen(false)}
                  >
                    <span
                      className="nav-link dropdown-toggle"
                      onClick={toggleServiceDropdown}
                    >
                      {name}
                    </span>

                    {serviceOpen && (
                      <ul className="dropdown-menu">
                        <li>
                          <Link to="/home-cleaning" onClick={closeMenu}>
                            Home Cleaning
                          </Link>
                        </li>
                        <li>
                          <Link to="/office-cleaning" onClick={closeMenu}>
                            Office Cleaning
                          </Link>
                        </li>
                        <li>
                          <Link to="/sofa-carpet-cleaning" onClick={closeMenu}>
                            Sofa & Carpet Cleaning
                          </Link>
                        </li>
                        <li>
                          <Link to="/bathroom-cleaning" onClick={closeMenu}>
                            Bathroom Deep Cleaning
                          </Link>
                        </li>
                        <li>
                          <Link to="/water-tank-cleaning" onClick={closeMenu}>
                            Water Tank Cleaning
                          </Link>
                        </li>
                        <li>
                          <Link to="/pest-control" onClick={closeMenu}>
                            Pest Control
                          </Link>
                        </li>
                        <li>
                          <Link to="/sanitization" onClick={closeMenu}>
                            Sanitization Services
                          </Link>
                        </li>
                      </ul>
                    )}
                  </li>
                );
              }

              return (
                <li key={name} className="nav-item">
                  <Link
                    to={path}
                    target={target}
                    className="nav-link"
                    onClick={closeMenu}
                  >
                    {name}
                  </Link>
                </li>
              );
            })}
          </ul>
        </div>

        {/* Center Logo */}
        <div className="navbar-logo">
          <Link to="/">SaafSafaiWale</Link>
        </div>
      </div>
    </header>
  );
}
